import { useQuery } from 'react-query';

import { User } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetUsersInOrg = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  const fetchOrgUsers = async () => {
    try {
      const res = await fetch(`${APIBaseChronos}/api/org/users`, fetchConfigGET);
      return await res.json();
    } catch (error) {
      console.error('Error fetching organization users:', error);
      return [];
    }
  };

  return useQuery<User[]>([QueryEntity.Users], fetchOrgUsers, {
    refetchOnWindowFocus: false,
  });
};
